import useBodyClass from '@components/Hooks/useBodyClass';
import useGlobalState from '@components/Hooks/useGlobalState';
import Termite from '@divtel/termite';
import Fader from '@Shared/Fader';
import React from 'react';
import { Col, Container as Grid, Row } from 'react-bootstrap';
import ChangePasswordError from './Error';
import ChangePasswordForm from './Form';
import ChangePasswordInstructions from './Instructions';
import ChangePasswordSuccess from './Success';


const ChangePassword: React.FC = () => {

  useBodyClass(['change-password-page']);
  const [store,] = useGlobalState();

  return (
    // @ts-ignore
    <Termite app='Change Password'>
      <div className='main-section'>
        <Fader>
          <Grid style={{ paddingTop: 30 }}>
            <ChangePasswordError />
            <ChangePasswordSuccess />
            {!store.change_password?._info.success ? (
              <Row>
                <Col sm={6}>
                  <ChangePasswordForm />
                </Col>
                <Col sm={6}>
                  <ChangePasswordInstructions />
                </Col>
              </Row>
            ) : (<span />)}
          </Grid>
        </Fader>
      </div>
    </Termite >
  );
}

export default ChangePassword;